<template>
    <div v-if="chartData">
        <div id="enterprise-comparison" style="width:1680px; height:558px;"></div>
    </div>
    <div v-else>
        <div style="line-height:500px">暂无数据</div>
    </div>
</template>

<script>
/* eslint-disable */

import * as echarts from "echarts";
import EventBus from "../js/event-bus";

export default {
    name: "EnterpriseComparison",
    data() {
        return {
            chartData: null,
        };
    },
    mounted() {
        EventBus.$on("showOrganizationDetail", (organizationId) => {
            if (!organizationId) {
                return;
            }
            this.getManufactureTwoYearGrowth(organizationId);
        });
    },
    methods: {
        getManufactureTwoYearGrowth(organizationId) {
            this.$api
                .getManufactureTwoYearGrowth(organizationId)
                .then((result) => {
                    if (result.ok === true) {
                        this.chartData = result.data;
                        setTimeout(() => {
                            this.drawLine();
                        }, 500);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        drawLine() {
            echarts
                .init(document.getElementById("enterprise-comparison"))
                .dispose(); // 销毁实例
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(
                document.getElementById("enterprise-comparison")
            );
            // 绘制图表
            myChart.setOption({
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999",
                        },
                    },
                },
                // title: {
                //     text: "危废产量同比",
                //     left: "center"
                // },
                // toolbox: {
                //   feature: {
                //     dataView: { show: true, readOnly: false },
                //     magicType: { show: true, type: ["line", "bar"] },
                //     restore: { show: true },
                //     saveAsImage: { show: true }
                //   }
                // },
                legend: {
                    // data: [
                    //     this.chartData.beginYear.toString(),
                    //     this.chartData.endYear.toString(),
                    //     "同比增长率",
                    //     "环比增长率",
                    // ],
                    orient: "vertical",
                    left: "right",
                    textStyle: {
                        color: "#cce2fc",
                    },
                },
                xAxis: [
                    {
                        type: "category",
                        data: [
                            "1月",
                            "2月",
                            "3月",
                            "4月",
                            "5月",
                            "6月",
                            "7月",
                            "8月",
                            "9月",
                            "10月",
                            "11月",
                            "12月",
                        ],
                        axisPointer: {
                            type: "shadow",
                        },
                        axisLabel: {
                            formatter: "{value}",
                            show: true,
                            textStyle: {
                                color: "#8DB6DB",
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "产废量",
                        axisLabel: {
                            formatter: "{value}",
                            show: true,
                            textStyle: {
                                color: "#8DB6DB",
                            },
                        },
                    },
                    {
                        type: "value",
                        name: "百分比",
                        axisLabel: {
                            formatter: "{value} %",
                        },
                    },
                ],
                series: [
                    {
                        type: "bar",
                        name: this.chartData.data[0].year.toString(),
                        data: this.chartData.data[0].amounts,
                    },
                    {
                        type: "bar",
                        name: this.chartData.data[1].year.toString(),
                        data: this.chartData.data[1].amounts,
                    },
                    {
                        name: "同比增长率",
                        type: "line",
                        smooth: true,
                        yAxisIndex: 1,
                        data: this.chartData.growthYearOnYear,
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                        },
                        markPoint: {
                            data: [{ type: "max", name: "最大值" }],
                        },
                    },
                    {
                        name: "环比增长率",
                        type: "line",
                        smooth: true,
                        yAxisIndex: 1,
                        data: this.chartData.growthMonthOnMonth,
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                        },
                        markPoint: {
                            data: [{ type: "max", name: "最大值" }],
                        },
                    },
                ],
            });
        },
    },
};
</script>

<style lang="less"></style>
